import { render, staticRenderFns } from "./baomi.vue?vue&type=template&id=58588c80"
import script from "./baomi.vue?vue&type=script&lang=js"
export * from "./baomi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports